<template>
  <v-container class="noPadding">
    <v-tabs slot="extension"
            dense
            v-model="settingsmodel"
            slider-color="orange">
      <v-tab :href="'#GeneralSettings'">
        General
      </v-tab>
      <v-tab :href="'#AccountSettings'">
        Account
      </v-tab>
      <v-tab :href="'#SecuritySettings'">
        Security
      </v-tab>
      <v-tab :href="'#NotificationSettings'">
        Notifications
      </v-tab>

      <v-tab-item :id="'GeneralSettings'">
        <GeneralSettings></GeneralSettings>
      </v-tab-item>
      <v-tab-item :id="'AccountSettings'">
        <AccountSettings></AccountSettings>
      </v-tab-item>
      <v-tab-item :id="'SecuritySettings'">
        <SecuritySettings></SecuritySettings> 
      </v-tab-item>
      <v-tab-item :id="'NotificationSettings'">
        <NotificationSettings></NotificationSettings>
      </v-tab-item>
    </v-tabs>
    

  </v-container>
</template>

<script>
  import GeneralSettings from './generalSettings/GeneralSettings.vue'
  import AccountSettings from './accountSettings/AccountSettings.vue'
  import SecuritySettings from './securitySettings/SecuritySettings.vue'
  import NotificationSettings from './notificationSettings/NotificationSettings.vue'

  export default {
    components: {
      'GeneralSettings': GeneralSettings,
      'AccountSettings': AccountSettings,
      'SecuritySettings': SecuritySettings,
      'NotificationSettings': NotificationSettings
    },
    data() {
      return {
        Saved: false,
        settingsmodel:'',
      }
    },
    methods: {
      selectSettings: function (item) {
        switch(item){
          case "general":
            this.settingsmodel = "GeneralSettings"
            break;
          case "account":
            this.settingsmodel = "AccountSettings"
            break;
          case "security":
            this.settingsmodel = "SecuritySettings"
            break;
          case "notification":
            this.settingsmodel = "NotificationSettings"
            break;
        }
      }
    },
    beforeMount() {
      this.selectSettings(this.$route.params.itemId)
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/settings/Settings.vue